exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bottom-menu :nth-child(1){overflow:hidden}.bottom-menu :nth-child(2){border-radius:20px 20px 0 0;overflow:visible}.bottom-menu .menu-top{top:-15px;position:absolute;margin-left:auto;margin-right:auto;left:0;right:0;width:55px;background:white;border-radius:25%;height:6px;opacity:0.6}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/Drawer/style.scss
// module id = 1920
// module chunks = 0